if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then(registrations => registrations.forEach(r => r.unregister()))
    .catch(() => undefined);
}

if ("caches" in window) {
  caches
    .keys()
    .then(keys =>
      keys
        .filter(key => key.indexOf("workbox-") === 0)
        .forEach(key => caches.delete(key))
    )
    .catch(() => undefined);
}

export {};
